import { useContext } from 'react';
import { ToastAlertContext } from 'store/toastAlertContext';

export const useToastAlert = () => useContext(ToastAlertContext);
